import { useSearchParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import { useDataFetch } from "../../../hooks/use-data-fetch";
import ResendConfirmationEmail from "../ResendConfirmationEmail";

const ConfirmEmailForm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("link");
  const { getData } = useDataFetch();

  const {
    isLoading,
    error,
  } = getData(
    ["confirm-email", token],
    token ? `/users/confirm/${token}` : "",
    {
      enabled: !!token, 
    }
  );

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <Card className="bg-white border-0 rounded-10 mb-4 text-center" style={{ maxWidth: "550px", margin: "0 auto" }}>
        <Card.Body className="p-4">
          <div className="mb-3 mb-md-4">
            <img src="/images/logo.svg" alt="logo" width={100} height={26} />
          </div>

          <img src="/images/message.svg" className="mb-3 mb-md-4" alt="mensaje" width={124} height={124} />

          <h4 className="fs-20 fw-semibold mb-2">
            {isLoading
              ? "Confirmando..."
              : error
              ? "Error"
              : "¡Confirmado!"}
          </h4>

          {!isLoading && !error && (
            <p className="mb-4 text-success">¡Tu correo ha sido confirmado exitosamente!</p>
          )}

          {!isLoading && error && (
            <>
              <p className="mb-3 text-danger">
                {error?.message || "Error al confirmar el correo."}
              </p>
              <div className="mb-4 text-start">
                <ResendConfirmationEmail />
              </div>
            </>
          )}

          <button
            type="button"
            className="btn btn-primary fs-16 fw-medium py-2 px-4 text-white w-100"
            disabled={isLoading}
            onClick={() => window.location.href = "/login"}
          >
            Ir a Iniciar Sesión
          </button>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ConfirmEmailForm;
